'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  flex: none;\n'], ['\n  flex: none;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _icons = require('@hackclub/icons');

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Icon = (0, _styledComponents2.default)(_Box2.default.withComponent(_icons2.default))(_templateObject);

Icon.displayName = 'Icon';

Icon.propTypes = {
  /** which icon to draw */
  glyph: _propTypes2.default.string,
  /** width/height, numbers in px */
  size: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
};

Icon.defaultProps = {
  glyph: 'flag',
  size: 24
};

exports.default = Icon;